var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"geogebra"},[(_vm.errorMessage)?_c('ErrorMessage',[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),_c('div',{ref:"geogebraApplet",staticClass:"geogebra-applet"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }